
export const getSharedAdvice = (state) =>
  state.sharedAdvice;

export const getSharedAdviceApplications = (state) =>
  state.sharedAdvice.applications;

export const getSharedAdviceApplicationId = (state) =>
  state.sharedAdvice.applicationId;

export const getSharedMachineId = (state) =>
  state.sharedAdvice.machine;

export const getSharedField = (state) => {
  let {workingWidth, applicationRate, applicationType,
    drivingSpeed } = state.sharedAdvice;
  return {WorkingWidth: workingWidth, applicationRate, applicationType,
    drivingSpeed};
};

export const getSharedTable = (state) => {
  let result = state.sharedAdvice.result;
  return (result===null) ? [] : result.Table;
};

export const getSharedTablePos = (state) => ({
  x: state.sharedAdvice.resultTableX,
  y: state.sharedAdvice.resultTableY
});

export const getSharedAppType = (state) => {
  switch(state.sharedAdvice.applicationType) {
    case 'LowTopDress':
      return 'fieldsettings_application_small_topdress_metric';
    case 'HighTopDress':
      return 'fieldsettings_application_large_topdress_metric';
    default:
      return 'fieldsettings_application_basic';
  }
};

export const getSharedProperties = (state) => {
  let {granuleSizeMinus2, granuleSizeB23, granuleSizeB34, granuleSize4,
    adviceDensity} = state.sharedAdvice;
  return {granuleSizeMinus2, granuleSizeB23, granuleSizeB34, granuleSize4,
    adviceDensity};
};

export const getSharedValidProperties = (state) => {
  let props = getSharedProperties(state);
  let {granuleSizeMinus2, granuleSizeB23, granuleSizeB34, granuleSize4} = props;
  let data = {};
  let t = 0;
  for (let i in props) {
    if(i!=='adviceDensity') {
      t += Number(props[i]);
    }
  }
  if(t===100) {
    data = {granuleSizeMinus2, granuleSizeB23, granuleSizeB34, granuleSize4};
  }
  if(props.adviceDensity!==0) {
    data['adviceDensity'] = props.adviceDensity;
  }
  return data;
};

export const getSharedAdviceApplication = (state) => {
  const applicationId = JSON.parse(getSharedAdviceApplicationId(state));
  const applications = getSharedAdviceApplications(state);
  if (applications) {
    for (let i in applications) {
      let r = applications[i].Applications.filter((app) =>
        app.Id === applicationId);
      if (r.length > 0) {
        return r[0];
      }
    }
  }
  return null;
};

export const getSharedAdviceTablePos = (state) => ({
  x: state.sharedAdvice.resultTableX,
  y: state.sharedAdvice.resultTableY
});



// WEBPACK FOOTER //
// ./src/store/selectors/sharedAdvice.js